export default __webpack_public_path__ + "static/media/eccomerce-logo.1350f3ae.png";